<template>
  <div v-if="productUrl" class="back-to-product">
    <Icon
      class="product-icon"
      :model="appStore.currentMode() === DisplayMode.Light ? props.model?.light : props.model?.dark"
    />

    <a class="product-button" :href="safeProductUrl">
      {{ t('header.backToProductButton.text') }}
    </a>
  </div>
</template>

<script setup lang="ts">
import Icon from './Icon.vue'
import { t } from '../composables/Translation'
import type { BackToProduct } from '../types/configuration/BackToProduct'
import { useAppStore } from '../stores/appStore'
import { DisplayMode } from '../types/app/displayMode'
import { computed } from 'vue'

const props = defineProps<{
  model: BackToProduct | undefined
}>()

const appStore = useAppStore()
const productUrl = props.model?.productUrl || ''

function sanitizeUrl(input: unknown): string {
  const raw = String(input ?? '').trim()
  if (!raw) return ''

  if (raw.startsWith('/') || raw.startsWith('#')) return raw

  try {
    const u = new URL(raw)
    if (u.protocol === 'http:' || u.protocol === 'https:') return u.toString()
    return ''
  } catch {
    return ''
  }
}

const safeProductUrl = computed(() => sanitizeUrl(props.model?.productUrl))
</script>

<style scoped>
.back-to-product {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-top: 3px;
  padding-left: 12px;
}

.product-button {
  text-decoration: none;
  color: inherit;
  font-size: 14px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 500;
  cursor: pointer;
  background: none;
  border: none;
}

.product-icon {
  width: 20px;
  height: 20px;
  display: flex;
}
</style>
